// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__17ztC","fadeInAnimation":"Header_fadeInAnimation__xg5qu","title":"Header_title__2RpXX","buttonHolder":"Header_buttonHolder__CGuZt"};